import api from "../../index.js";
import { qs } from "../../../utils/utils.js";

export const GetSupportTicketApi = (params) => api.get(`ticket/get-all-tickets?${qs(params)}`);
export const GetTicketByIdApi = (ticketId) => api.get(`ticket/get-ticket-details-byid/${ticketId}`);
export const UpdateTicketApi = (data) => api.post('ticket/update-ticket-status', data);
export const UpdateassingTicketApi = (data) => api.post('TicketMaster/Notify-To-Admin', data);
export const GetTicketChatApi = (data, headers) => api.post('ticket/add-ticket-detail', data, headers);
